import { Badge } from "@babackapp/ui/components/badge";
import useTranslation from "@babackapp/translations/use-translation";
import { CreditCardIcon } from "lucide-react";

// BBS-237 follow-up: surfaces "complement payment not verified" without
// touching status.error (which gates merchant Validate/Reject actions —
// see get-status-from-return-request.ts and use-validate-action.tsx).
export default function PaymentAttentionBadge({
  isPaymentAttentionNeeded,
}: {
  isPaymentAttentionNeeded?: boolean | null;
}) {
  const t = useTranslation();

  if (!isPaymentAttentionNeeded) {
    return null;
  }

  return (
    <Badge
      variant="outline"
      className="gap-1 border-transparent bg-amber-100 text-amber-700"
    >
      <CreditCardIcon className="h-4 w-4" />
      {t("returnDetail.paymentAttentionNeeded")}
    </Badge>
  );
}
